import { STATUS_STYLES, PRIORITY_STYLES, TYPE_STYLES, SHORT_STATUS } from "@/lib/status";

export { STATUS_STYLES };

const base = "inline-flex items-center px-2.5 py-0.5 rounded-sm border text-[11px] font-medium uppercase tracking-wider whitespace-nowrap";

export default function StatusBadge({ status, testid, className = "" }) {
  const cls = STATUS_STYLES[status] || STATUS_STYLES.Pending;
  return <span data-testid={testid} className={`${base} ${cls} ${className}`}>{SHORT_STATUS[status] || status}</span>;
}

export function PriorityBadge({ priority, testid }) {
  if (!priority || priority === "Normal") return null;
  return <span data-testid={testid} className={`${base} ${PRIORITY_STYLES[priority] || PRIORITY_STYLES.Normal}`}>{priority}</span>;
}

export function TypeBadge({ type, testid }) {
  if (!type || type === "Rework") return null;
  return <span data-testid={testid} className={`${base} ${TYPE_STYLES[type]}`}>{type}</span>;
}

export function AgeBadge({ flag, testid }) {
  if (!flag) return null;
  const cls = flag.level === "overdue" ? "bg-red-50 text-red-700 border-red-300" : "bg-amber-50 text-amber-700 border-amber-300";
  return <span data-testid={testid} className={`${base} ${cls}`}>{flag.label}</span>;
}
